import type { CategoryFilter } from "../../../shared/types";

interface HabitEmptyStateProps {
  readonly categoryFilter: CategoryFilter;
}

export function HabitEmptyState({ categoryFilter }: HabitEmptyStateProps) {
  const filterLabel =
    categoryFilter === "all"
      ? "aucune catégorie"
      : categoryFilter === "spiritual"
        ? "spirituel"
        : categoryFilter === "personal"
          ? "personnel"
          : categoryFilter === "professional"
            ? "professionnel"
            : categoryFilter === "health"
              ? "santé"
              : categoryFilter === "finance"
                ? "finance"
                : categoryFilter === "learning"
                  ? "apprentissage"
                  : categoryFilter === "social"
                    ? "social"
                    : categoryFilter === "creativity"
                      ? "créativité"
                      : "autre";

  return (
    <div className="flex flex-col items-center justify-center py-12 gap-4">
      <svg
        viewBox="0 0 24 24"
        className="w-12 h-12 text-ink-faint"
        stroke="currentColor"
        strokeWidth={2}
        fill="none"
        aria-hidden="true"
      >
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <rect x="8" y="2" width="8" height="4" rx="1" />
        <polyline points="9 14 11 16 15 12" />
      </svg>
      <p className="text-ink font-semibold text-sm">Aucune habitude</p>
      <div className="text-center space-y-1 max-w-xs">
        <p className="text-ink-faint text-xs">
          {categoryFilter === "all"
            ? "Créez votre première habitude, puis cochez-la chaque jour pour construire une série."
            : `Aucune habitude dans la catégorie ${filterLabel}. Commencez par en créer une !`}
        </p>
        <p className="text-ink-faint text-xs">
          Plus votre série est longue, plus vous progressez.
        </p>
      </div>
    </div>
  );
}
